import { UntypedFormGroup } from '@angular/forms';

export const getChangedFields = (form: UntypedFormGroup): string[] => {
  const changedFields: string[] = [];
  Object.keys(form.value).forEach((key) => {
    const control = form.get(key);
    if (control && control.dirty) {
      changedFields.push(key);
    }
  });
  return changedFields;
};
